module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_1@3x.1a27a45f.png";